import axios from 'axios';

export async function pollAssessment(api, email, userId, onStage) {
  const deadline = Date.now() + 550000;
  while (Date.now() < deadline) {
    let data;
    try {
      const response = await axios.get(`${api}/trial/analysis-status`, {
        params: { email, ...(userId ? { user_id: userId } : {}) }, timeout: 15000,
      });
      data = response.data;
    } catch (error) {
      if (error.response?.status === 404) throw new Error('Assessment request was not found. Please submit again.');
      // Retry only transport failures, never an application-reported failure.
      await new Promise(resolve => setTimeout(resolve, 4000));
      continue;
    }
    if (data.status === 'error') {
      const error = new Error(data.error || 'Assessment could not be completed. No empty report was published.');
      error.terminal = true;
      throw error;
    }
    if (data.status === 'ready') return data;
    onStage?.(data.stage || 'Analyzing company disclosures...');
    await new Promise(resolve => setTimeout(resolve, 4000));
  }
  throw new Error('The assessment has not completed. Your request is saved; submitting again will check the same request, not create another.');
}

export function assessmentRequest(formData, files) {
  const fingerprint = JSON.stringify([formData, files.map(f => [f.name, f.size, f.lastModified])]);
  let saved;
  try { saved = JSON.parse(sessionStorage.getItem('samanvai_pending_assessment')); } catch { /* old invalid storage */ }
  if (saved?.fingerprint === fingerprint) return saved;
  const request = { fingerprint, requestId: crypto.randomUUID() };
  sessionStorage.setItem('samanvai_pending_assessment', JSON.stringify(request));
  return request;
}

export async function fetchValueReport(url, headers, retry = false) {
  const deadline = Date.now() + 510000;
  let autoRetried = false;
  while (Date.now() < deadline) {
    let response;
    try {
      response = await axios.get(url, { headers, timeout: 20000, params: retry ? { retry: true } : undefined });
    } catch (err) {
      // A failed or interrupted report job returns 503; restart it once automatically.
      if (err.response?.status === 503 && !autoRetried) {
        autoRetried = true;
        retry = true;
        continue;
      }
      throw err;
    }
    retry = false;
    if (response.status !== 202) return response;
    await new Promise(resolve => setTimeout(resolve, 4000));
  }
  throw new Error('The detailed report has not completed. Your company assessment is still available.');
}